import {lazy, FC, Suspense, useState} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {useAuth} from '../modules/auth'
import {OperationDashboard} from '../pages/Operational-Dashboard/OperationalDashboard'
import {FinancialDashboard} from '../pages/Financial-Dashboard/FinancialDashboard'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const AccountPage = lazy(() => import('../../app/UI/UserProfileView/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  // const UsersPage = lazy(() => import('../UI/user-management/UsersPage'))
  const UsersPage = lazy(() => import('../../app/UI/user-management/UsersPage'))
  const RolesPage = lazy(() => import('../../app/UI/user-role-management/RolesPage'))

  const {currentUser} = useAuth()
  const [currency, setCurrency] = useState('IDR') // Default currency

  return (
    <Routes>
      <Route element={<MasterLayout setCurrency={setCurrency} currency={currency} />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route
          path='auth/*'
          element={
            currentUser?.user?.user_type === 'ADMIN' ? (
              <Navigate to='/dashboard' />
            ) : currentUser?.user?.user_type === 'CUS' ? (
              <Navigate to='/customer-dashboard' />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />

        {/* Pages */}
        <Route
          path='dashboard'
          element={
            currentUser?.user?.user_type === 'ADMIN' ? (
              <DashboardWrapper currency={currency} />
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='/customer-dashboard'
          element={
            currentUser?.user?.user_type === 'CUS' ? (
              <SuspensedView>
                <OperationDashboard currency={currency} />
              </SuspensedView>
            ) : (
              <Navigate to='/error/404' />
            )
          }
        />
        <Route
          path='/financial-dashboard'
          element={
            <SuspensedView>
              <FinancialDashboard currency={currency} />
            </SuspensedView>
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
